import * as React from 'react';

function SvgCoverPhoto(props) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" {...props}>
      <path
        d="M8.667 0h34.666C49.111 0 52 2.889 52 8.667v34.666C52 49.111 49.111 52 43.333 52H8.667C2.889 52 0 49.111 0 43.333V8.667C0 2.889 2.889 0 8.667 0z"
        fill="#248C85"
      />
      <path
        d="M26 0h17.333A8.667 8.667 0 0152 8.667v34.666A8.667 8.667 0 0143.333 52H8.667A8.667 8.667 0 010 43.333V26C0 11.642 11.642 0 26 0z"
        fill="#38B2A6"
      />
      <path d="M34.533 14.267a3.2 3.2 0 106.4 0 3.2 3.2 0 00-6.4 0z" fill="#fff" />
      <path
        d="M32.76 23.745l-7.09 12.52a2.133 2.133 0 001.856 3.184h11.022a4.267 4.267 0 003.627-6.515l-5.745-9.26a2.133 2.133 0 00-3.67.071z"
        fill="#ABD9D0"
      />
      <path
        d="M18.922 19.457l-8.17 13.423a4.267 4.267 0 003.64 6.485h20.026l-11.84-19.889a2.133 2.133 0 00-3.656-.021v.002z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgCoverPhoto;
